import queryString from 'query-string';
import { getRegistrationParams } from '../../services/auth';

export const buildLoginPath = () => {
  const queryParams = queryString.parse(window.location.search);
  const registrationParams = getRegistrationParams();
  const clientId = queryParams.clientId || registrationParams.clientId;
  const callbackUri = queryParams.callbackUri || registrationParams.callbackUri;

  const loginParams = queryString.stringify({
    ...(clientId && { clientId }),
    ...(callbackUri && { callbackUri }),
  });

  return loginParams ? `/login?${loginParams}` : '/login';
};

export const buildRegisterPath = () => {
  const queryParams = queryString.parse(window.location.search);
  const registrationParams = getRegistrationParams();
  const clientId = queryParams.clientId || registrationParams.clientId;
  const callbackUri = queryParams.callbackUri || registrationParams.callbackUri;

  const registerParams = queryString.stringify({
    ...(clientId && { clientId }),
    ...(callbackUri && { callbackUri }),
  });

  return registerParams ? `/register?${registerParams}` : '/register';
};

export const redirectToLogin = (history) => {
  const path = buildLoginPath();
  if (history && typeof history.push === 'function') {
    history.push(path);
  } else {
    window.location.replace(path);
  }
};
